<template>
  <div>   
    <Header />
    <SidebarContact />
    <router-view />
    <Footer />
  </div>
</template>

<script>
  import Header from '../components/Header.vue';
  import Footer from '../components/Footer.vue';
  import SidebarContact from '../components/SidebarContact.vue';

  export default {
    data() {
      return {
        prevScrollpos: window.pageYOffset,
      }
    },
    components: {
      Header,
      Footer,
      SidebarContact
    },
    methods: {
      handleScroll(e) {
        let header = document.querySelector(".public-header");
        const currentScrollPos = window.pageYOffset;

        if (currentScrollPos < 100) {
          header.classList.remove("nav-up")
        } 
        else {
          header.classList.add("nav-up");  
        }

        this.prevScrollpos = currentScrollPos
      
      },
    },
    created () {
      if(window.window.innerWidth > 1023 ) {
        window.addEventListener('scroll', this.handleScroll);
      }
    },
    beforeDestroy() {
      if(window.window.innerWidth > 1023 ) {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }
</script>

<style>

</style>
